module.exports = __webpack_public_path__ + "fcec1306f25701c9a98fe49ba84460e7.png";